import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import {
  ProductVolumePricingModal,
  useProductVolumePricingContext,
} from '../../../../../product'
import { ProductSearchResultItemGenericLabel } from '../ProductSearchResultItemGenericLabel'

export const ProductSearchResultItemVolumePricingLabel: FC = () => {
  const { openableControls } = useProductVolumePricingContext()

  return (
    <>
      <ProductSearchResultItemGenericLabel
        className="border-light-primary-strong bg-light-tertiary text-dark-primary-max"
        data-qa-id="volume-pricing-modal-button"
        name="productLabelVolumePricing"
        onClick={openableControls.handleOpen}
      >
        <>
          <FormattedMessage id="volumePricing.modal.title" />
          <IconInfo className="ml-2 size-4" />
        </>
      </ProductSearchResultItemGenericLabel>
      <ProductVolumePricingModal />
    </>
  )
}
